import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { globalAlert, globalLoader } from "../../actions/commonActions";
import { getCsvFile } from "../../superadmin/_actions";
import FileDownload from "js-file-download";
import { logOut } from "../../_shared/commonFunction";
import ConfirmationModal from "../_common/confirmModal";
import InputComponent from "../_common/inputComponent";
import { adminZonerListApi } from "../../admin/_actions";

const EditConfig = (props) => {
  const { t } = useTranslation();
  const [passwordLength, setPasswordLength] = useState(6);
  const [lockoutTime, setLockoutTime] = useState(5);
  const [passwordLengthErr, setPasswordLengthErr] = useState(false);
  const [lockoutTimeErr, setLockoutTimeErr] = useState(false);

  useEffect(() => {
    setPropsToState(); // eslint-disable-next-line
  }, [props?.data]);

  const setPropsToState = () => {
    if(props?.data?.passwordLength) {
      setPasswordLength(props?.data?.passwordLength || passwordLength);
    }
    if(props?.data?.lockoutTime) {
      setLockoutTime(props?.data?.lockoutTime || lockoutTime);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (await handleValidation()) {
      globalLoader(true);
      let formData = new FormData();
      formData.append("passwordLength", passwordLength);
      formData.append("lockoutTime", lockoutTime);
      props.valueSubmit(formData);
    }
  };

  const handleValidation = () => {
    let flag = true;
    if (passwordLength < 6) {
      setPasswordLengthErr(true);
      flag = false;
    }

    if (lockoutTime < 5) {
      setLockoutTimeErr(true);
      flag = false;
    }
    return flag;
  };

  return (
    <>
    <form onSubmit={handleSubmit} className="form-own px-3">
      <div className="col-12">
        <div className="box-wrapper d-flex flex-wrap w-100 w-full justify-content-center">
          <div className="flex-1 d-flex flex-wrap col-6">
            <InputComponent
              placeholder="Password length"
              label={t("superadmin.config.passwordLength")}
              type="number"
              min={6}
              max={18}
              name="passwordLength"
              theme="admin"
              value={passwordLength}
              handleCallback={(val) => setPasswordLength(val)}
            />
            <div className="error-text">
              {!passwordLength && passwordLengthErr && (
                <span>{t("superadmin.config.passwordLengthRequired")}</span>
              )}
            </div>
          </div>
          <div className="flex-1 d-flex flex-wrap col-6">
            <InputComponent
              placeholder="Lockout Time"
              label={t("superadmin.config.lockoutTime")}
              type="number"
              min={5}
              name="lockoutTime"
              theme="admin"
              value={lockoutTime}
              handleCallback={(val) => setLockoutTime(val)}
            />
            <div className="error-text">
              {!lockoutTime && lockoutTimeErr && (
                <span>{t("superadmin.config.lockoutTimeRequired")}</span>
              )}
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap col-12 ml-auto mt-3 justify-content-center">
          <button
            type="submit"
            className="min-width-btn-xs ml-3 btn primary-btn"
          >
            {t("common.save")}
          </button>
        </div>
      </div>
    </form>
    </>
  );
};

export default EditConfig;
